import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useI18n } from '../../i18n';

const STEPS = ['01','02','03','04','05','06'];

const Process = () => {
  const { t } = useI18n();
  return (
    <section id="process" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">{t('process.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900">{t('process.title')}</h2>
          <p className="mt-4 text-slate-600">{t('process.body')}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {STEPS.map((step) => {
            const items = t(`process.steps.${step}.items`) || [];
            return (
              <div key={step} className="relative rounded-2xl bg-white border border-slate-200 p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="absolute -top-4 left-6 bg-slate-900 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                  {t('process.stepPrefix')} {step}
                </div>
                <div className="text-orange-500 text-xs font-semibold uppercase tracking-widest mt-2">{t(`process.steps.${step}.tag`)}</div>
                <h3 className="mt-2 text-xl font-bold text-slate-900">{t(`process.steps.${step}.title`)}</h3>
                <ul className="mt-4 space-y-2">
                  {items.map((it) => (
                    <li key={it} className="flex items-center gap-2 text-sm text-slate-700">
                      <CheckCircle2 className="h-4 w-4 text-emerald-500" /> {it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
